import {
  FV_SNACKBAR_COLOR,
  FV_SNACKBAR_DISPLAY,
  IFvSnackbarOption,
} from '@discocil/fv-components';

export const bluetoothPrinterConnectedSuccess: IFvSnackbarOption = {
  title: '',
  message: 'fv_snackbar.connect_printer.success_msg',
  hasIconClose: false,
  color: FV_SNACKBAR_COLOR.green,
  display: FV_SNACKBAR_DISPLAY.inline,
  hasIcon: false,
  timeBeforeClose: 3000,
};

export const bluetoothPrinterConnectedFailed: IFvSnackbarOption = {
  title: '',
  message: 'fv_snackbar.connect_printer.failed_msg',
  hasIconClose: false,
  color: FV_SNACKBAR_COLOR.red,
  display: FV_SNACKBAR_DISPLAY.inline,
  hasIcon: false,
  timeBeforeClose: 3000,
};

export const noBluetoothDevices: IFvSnackbarOption = {
  title: '',
  message: 'fv_snackbar.bluetooth_devices.not_found',
  hasIconClose: false,
  color: FV_SNACKBAR_COLOR.red,
  display: FV_SNACKBAR_DISPLAY.inline,
  hasIcon: false,
  timeBeforeClose: 3000,
};
